import { CFIconBarChart } from './bar-chart';
import { CFIconBarChart2 } from './bar-chart-2';
import { CFIconBriefcase } from './briefcase';
import { CFIconCreditCard } from './credit-card';
import { CFIconPercent } from './percent';
import { CFIconPieChart } from './pie-chart';
import { CFIconTrendingDown } from './trending-down';
import { CFIconTrendingUp } from './trending-up';
export const CFIconGroupBusiness = [
    CFIconBarChart,
    CFIconBarChart2,
    CFIconBriefcase,
    CFIconCreditCard,
    CFIconPercent,
    CFIconPieChart,
    CFIconTrendingDown,
    CFIconTrendingUp,
];
